import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "px-4 py-4 w-full sticky bg-brand-black top-0 z-50 border-b border-brand-dark-gray",
  id: "tagSearch"
}
const _hoisted_2 = {
  key: 2,
  class: "flex w-full h-full"
}
const _hoisted_3 = { class: "flex w-full" }

import InputField from "@/components/InputField.vue";
import {nextTick, onMounted, onUnmounted, onUpdated, reactive, Ref, ref, watch} from "vue";
import ApiService from "@/services/api/apiService";
import _ from "lodash";
import {
  IonImg,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,
  IonContent,
  useIonRouter
} from "@ionic/vue";
import {FeedPostInterface} from "@/interfaces/FeedPostInterface";
import {PostPrivacy} from "@/definitions/PostPrivacy";
import {v4 as uuidv4} from "uuid";
import {bus} from "ionicons/icons";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import FeedTagPost from "@/components/FeedTagPost.vue";
import FeedPost from "@/components/FeedPost.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchTags',
  props: {
  hashtag: {
    type: String,
    default: ''
  },
  canSearch: {
    type: Boolean,
    default: true
  },
  embedded: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const loading = ref(true)
const search = ref('')
const posts: Ref<any> = ref([])
const meta: Ref<any> = ref()
const showInfiniteScroll = ref(true)

const busy = ref(false)
const containerId = uuidv4()


const ionRouter = useIonRouter()

const props = __props

const itemSize = ref(0)
const observer = ref()
const user = ref()

onMounted(async () => {

  user.value = await ApiService.User().authUser()
  itemSize.value = window.outerWidth / 3

  observer.value = Observable.subscribe(async (response: any) => {
    if (response.event === ObservableEvent.SearchScrollTop) {
      scrollContainer.value.$el.scrollTop = 0
      await getPosts(search.value, 1)
    }
  })

  await getPosts(props.hashtag.replace('#', ''))
  setContainerHeight()
  addContainerEventListeners()


})

const setContainerHeight = () => {
  if (!scrollContainer.value?.$el) return
  const scrollHost = scrollContainer.value.$el.closest('ion-content')
      ?? scrollContainer.value.$el.closest('.desktop-shell-main')
  const containerHeight = scrollHost?.clientHeight
  if (!containerHeight) return
  scrollContainer.value.$el.style.height = `${containerHeight - (props.embedded ? 0 : 89)}px`
}

onUpdated(async () => {
  await nextTick()
})

onUnmounted(() => {
  observer.value?.unsubscribe()
})

const addContainerEventListeners = () => {
  scrollContainer.value.$el.addEventListener("scroll", () => {
    handleScroll()
  });
}

watch(() => search.value, async tag => {
  await getPosts(tag)
})

const getPosts = async (tag = '', page = 1) => {
  if (busy.value) return
  busy.value = true
  const feedPosts = await ApiService.Search().tags(tag, page)
  meta.value = feedPosts.meta

  if (page === 1) {
    scrollContainer.value.$el.scrollTop = 0
    posts.value = feedPosts.data
  } else {
    posts.value = [...posts.value, ...feedPosts.data]
  }
  loading.value = false
  busy.value = false
}

const refresh = async (ev: any) => {
  await getPosts(search.value)

  ev.target.complete()
  showInfiniteScroll.value = true
}

const loadMore = async () => {
  let page = meta.value.current_page + 1
  if (page > meta.value.last_page) {
    return
  }
  await getPosts(search.value, page)
}

const viewPost = async (post: FeedPostInterface) => {
  ionRouter.navigate({
    name: 'SearchViewPost',
    params: {
      postId: post.id
    }
  }, 'forward', 'push')

}


const handleScroll = async () => {
  const threshold = 300; // Adjust this threshold as needed
  const containerHeight = scrollContainer.value.$el.closest('ion-content')?.clientHeight
  const isScrolledToBottom = scrollContainer.value.$el.scrollTop >= scrollContainer.value.$el.offsetHeight - threshold;
  if (isScrolledToBottom) await loadMore()
}

const scrollContainer: Ref<any> = ref(null)



return (_ctx: any,_cache: any) => {
  const _component_DynamicScrollerItem = _resolveComponent("DynamicScrollerItem")!
  const _component_DynamicScroller = _resolveComponent("DynamicScroller")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.embedded ? 'div' : 'ion-content'), {
    "force-overscroll": __props.embedded ? undefined : false,
    class: _normalizeClass(__props.embedded ? 'search-tags flex flex-col w-full min-h-full' : '')
  }, {
    default: _withCtx(() => [
      (!__props.embedded)
        ? (_openBlock(), _createBlock(_unref(IonRefresher), {
            key: 0,
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (refresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRefresherContent), {
                "pulling-icon": "crescent",
                "refreshing-spinner": "crescent"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.canSearch && !loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(InputField, {
              placeholder: "e.g. monochromemonday",
              "clear-input": true,
              debounce: 250,
              modelValue: search.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event))
            }, {
              "icon-start": _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z",
                    stroke: "#FFFFFF",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)
              ]))]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              class: "animate-spin h-10 w-10 m-auto text-white",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }),
              _createElementVNode("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              })
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
      _createVNode(_component_DynamicScroller, {
        ref_key: "scrollContainer",
        ref: scrollContainer,
        items: posts.value,
        "min-item-size": 600,
        class: "scroller flex"
      }, {
        default: _withCtx(({ item, index, active }) => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DynamicScrollerItem, {
              item: item,
              active: active,
              "data-index": index,
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(FeedPost, {
                  "auth-user": user.value,
                  post: item
                }, null, 8, ["auth-user", "post"])
              ]),
              _: 2
            }, 1032, ["item", "active", "data-index"])
          ])
        ]),
        _: 1
      }, 8, ["items"])
    ]),
    _: 1
  }, 8, ["force-overscroll", "class"]))
}
}

})